/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateHookActionPayload
 */
export interface ValidateHookActionPayload {
    /**
     * 
     * @type {string}
     * @memberof ValidateHookActionPayload
     */
    action_type: ValidateHookActionPayloadActionTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ValidateHookActionPayload
     */
    config: object;
}


/**
 * @export
 */
export const ValidateHookActionPayloadActionTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    Push: 'push',
    Teams: 'teams'
} as const;
export type ValidateHookActionPayloadActionTypeEnum = typeof ValidateHookActionPayloadActionTypeEnum[keyof typeof ValidateHookActionPayloadActionTypeEnum];


/**
 * Check if a given object implements the ValidateHookActionPayload interface.
 */
export function instanceOfValidateHookActionPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action_type" in value;
    isInstance = isInstance && "config" in value;

    return isInstance;
}

export function ValidateHookActionPayloadFromJSON(json: any): ValidateHookActionPayload {
    return ValidateHookActionPayloadFromJSONTyped(json, false);
}

export function ValidateHookActionPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateHookActionPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action_type': json['action_type'],
        'config': json['config'],
    };
}

export function ValidateHookActionPayloadToJSON(value?: ValidateHookActionPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': value.action_type,
        'config': value.config,
    };
}

